<!-- eslint-disable max-lines -->
<template>
  <div class="customer-list-page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        class="query-form"
        @submit.native.prevent
      >
        <el-row
          :gutter="20"
          class="query-row"
        >
          <el-col
            v-show="queryFieldVisibility.keyword"
            :span="6"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.keyword"
                clearable
                placeholder="请输入客户名称/编号、销售、产品名称"
                style="width: 100%"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>
          <el-col
            v-show="queryFieldVisibility.has_sales"
            :span="6"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.has_sales"
                clearable
                placeholder="是否有销售"
                style="width: 100%"
                @change="handleFilter"
              >
                <el-option
                  v-for="v in yn_ops"
                  :key="v.id"
                  :value="v.id"
                  :label="v.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-show="queryFieldVisibility.has_products"
            :span="6"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.has_products"
                clearable
                placeholder="是否有产品"
                style="width: 100%"
                @change="handleFilter"
              >
                <el-option
                  v-for="v in yn_ops"
                  :key="v.id"
                  :value="v.id"
                  :label="v.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-show="queryFieldVisibility.is_big_customer"
            :span="6"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.is_big_customer"
                clearable
                placeholder="是否大客户"
                style="width: 100%"
                @change="handleFilter"
              >
                <el-option
                  v-for="v in yn_ops"
                  :key="v.id"
                  :value="v.id"
                  :label="v.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="queryActionSpan"
            class="query-item query-item--actions"
          >
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>
              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>
              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <el-table
        :data="table.list"
        style="width: 100%"
        stripe
        border
      >
        <el-table-column
          prop="customer_id"
          label="客户编号"
          width="120"
        />
        <el-table-column
          prop="company"
          label="客户名称"
        >
          <template slot-scope="scope">
            <a
              style="color: #407aff;"
              @click="toProductList(scope.row)"
            >
              {{ scope.row.company }}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="sales"
          label="销售"
        >
          <template slot-scope="scope">
            <div>{{ scope.row._sales }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="products"
          label="合作产品"
          width="400"
        >
          <template slot-scope="scope">
            <div v-if="scope.row._prods.length">
              <el-tag
                v-for="(pi, pin) in scope.row._prods"
                :key="pin"
                style="margin: 0 8px 8px 0;"
                type="success"
              >
                {{
                  pi
                }}
              </el-tag>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_big_customer"
          label="是否大客户"
        >
          <template slot-scope="scope">
            <div>
              {{ yn_dicts[scope.row.is_big_customer] || '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="178"
        >
          <template slot-scope="scope">
            <el-dropdown
              class="opreate"
              @command="_operate"
            >
              <el-button
                size="small"
                @click="modifyProduct(scope.row)"
              >
                修改合作产品
                <i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item :command="[bindADV, scope.row]">关联ADV账户</el-dropdown-item> -->
                <el-dropdown-item :command="[deleteCustomer, scope.row]">删除客户</el-dropdown-item>
                <el-dropdown-item :command="[modifyCompanyName, scope.row]">修改公司名</el-dropdown-item>
                <el-dropdown-item :command="[modifySaler, scope.row]">修改销售</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.page"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- edit company dialog -->
    <form-dialog
      :visible.sync="modifyCompanyDlg.visible"
      title="修改公司名称"
      :loading="modifyCompanyDlg.loading"
      width="500px"
      @submit="submitModifyCompanyForm"
    >
      <el-form
        ref="modifyCompanyForm"
        :model="modifyCompanyDlg.form"
        label-width="60px"
        @submit.native.prevent
      >
        <el-form-item
          label="名称"
          prop="company"
          :rules="[{ required: true, message: '名称不能为空' }]"
        >
          <el-input
            v-model="modifyCompanyDlg.form.company"
            placeholder="请输入公司名称"
            @keyup.enter.native="submitModifyCompanyForm"
          />
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- bind adv dialog -->
    <form-dialog
      :visible.sync="bindAdvDlg.visible"
      title="绑定ADV账户"
      :loading="bindAdvDlg.loading"
      width="500px"
      @submit="submitBindAdvDlgForm"
    >
      <el-form
        ref="bindAdvForm"
        :model="bindAdvDlg.form"
        label-width="80px"
      >
        <el-form-item
          label="ADV账号"
          prop="adv_user_id"
          :rules="[{ required: true, message: 'ADV账号不能为空' }]"
        >
          <el-select
            v-model="bindAdvDlg.form.adv_user_id"
            clearable
            filterable
            remote
            reserve-keyword
            placeholder="请输入并选择ADV账号"
            :remote-method="_searchAdv"
            :loading="bindAdvDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in bindAdvDlg.saleOps"
              :key="item.id"
              :label="item.id + ' ' + item.company"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="saleUserName"
          label="账户名"
        >
          <el-input
            v-model="saleUserName"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          v-show="saleAgentName"
          label="代理商"
        >
          <el-input
            v-model="saleAgentName"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item
          label="合作产品"
          prop="product_id"
          :rules="[{ required: true, message: '合作产品不能为空' }]"
        >
          <el-select
            v-model="bindAdvDlg.form.product_id"
            clearable
            filterable
            placeholder="请选择合作产品"
            style="width: 100%"
          >
            <el-option
              v-for="item in bindAdvDlg.prodOps"
              :key="item.product_id"
              :label="item.product_name"
              :value="item.product_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- edit prod dialog -->
    <form-dialog
      :visible.sync="editProdDlg.visible"
      title="修改合作产品"
      :loading="editProdDlg.loading"
      width="600px"
      @submit="_processEditProd"
    >
      <el-form label-width="100px">
        <el-form-item label="已合作产品">
          <div v-if="editProdDlg.prods.length">
            <el-tag
              v-for="v in editProdDlg.prods"
              :key="v.product_id"
              size="small"
            >
              {{ v.product_name || '' }}
            </el-tag>
          </div>
          <div v-else>--</div>
        </el-form-item>
        <el-form-item label="合作产品">
          <el-select
            v-model="editProdDlg.selectedProd"
            multiple
            filterable
            remote
            :remote-method="_searchProduct"
            :loading="editProdDlg.searchLoading"
            placeholder="请选择合作产品"
            style="width: 100%"
          >
            <el-option
              v-for="item in editProdDlg.prodOps"
              :key="item.product_id"
              :label="item.product_name"
              :value="item.product_id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- edit prod salor dialog -->
    <form-dialog
      :visible.sync="editProdSalorDlg.visible"
      title="修改销售"
      :loading="editProdSalorDlg.loading"
      width="600px"
      @submit="submitEditProdSalor"
    >
      <el-form
        ref="prodSalorForm"
        label-width="90px"
        :model="editProdSalorDlg.form"
      >
        <el-form-item
          label="客保销售"
          prop="owner"
        >
          <el-select
            v-model="editProdSalorDlg.form.owner"
            filterable
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="请输入并选择销售"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import FormDialog from '@/components/FormDialog';

const req = new Request();

// const
const YN_OPTIONS = {
  yes: { id: '1', text: '是' },
  no: { id: '2', text: '否' },
};
const QUERY_FIELDS = [
  'keyword',
  'has_sales',
  'has_products',
  'is_big_customer',
];
const COLLAPSED_QUERY_FIELD_COUNT = 3;
const createDefaultQuery = () => ({
  keyword: '',
  has_sales: '',
  has_products: '',
  is_big_customer: '',
  page: 1,
  page_size: 10,
});

export default {
  name: 'OperationManageCustomerList',
  components: {
    FormDialog,
  },
  data() {
    return {
      // ops
      yn_ops: Object.values(YN_OPTIONS),
      yn_dicts: Object.values(YN_OPTIONS).reduce((r, v) => {
        r[v.id] = v.text;
        return r;
      }, {}),

      // list
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      queryExpanded: true,
      query: createDefaultQuery(),

      // dlg
      deleteCustomerDlg: {
        form: {
          customer_id: '',
        },
      },
      modifyCompanyDlg: {
        visible: false,
        loading: false,
        form: {
          customer_id: '',
          company: '',
        },
      },
      bindAdvDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        saleOps: [],
        prodOps: [],
        form: {
          product_id: '',
          adv_user_id: '',
          customer_id: '',
        },
      },
      editProdDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        prods: [],
        prodOps: [],
        initSelectedProds: [],
        selectedProd: [],
        form: {
          add_pids: '',
          sub_pids: '',
          customer_id: '',
        },
      },
      editProdSalorDlg: {
        visible: false,
        loading: false,
        searchLoading: false,
        options: [],
        form: {
          owner: '',
          customer_id: '',
          product_id: '',
        },
      },
    };
  },

  computed: {
    queryFieldVisibility() {
      return QUERY_FIELDS.reduce((result, key, index) => {
        result[key] = this.queryExpanded || index < COLLAPSED_QUERY_FIELD_COUNT;
        return result;
      }, {});
    },
    showQueryToggle() {
      return QUERY_FIELDS.length > COLLAPSED_QUERY_FIELD_COUNT;
    },
    queryActionSpan() {
      return this.queryExpanded ? 24 : 6;
    },
    saleUserName() {
      return (
        (
          this.bindAdvDlg.saleOps.find(
            (i) => i.id === this.bindAdvDlg.form.adv_user_id,
          ) || {}
        ).username || ''
      );
    },
    saleAgentName() {
      return (
        (
          this.bindAdvDlg.saleOps.find(
            (i) => i.id === this.bindAdvDlg.form.adv_user_id,
          ) || {}
        ).belong_username || ''
      );
    },
  },

  created() {
    this._getCustomerList();
  },

  methods: {
    // 测试修改销售
    modifySaler(item) {
      this.editProdSalorDlg.form.customer_id = item.customer_id;
      this.editProdSalorDlg.form.product_id = item.product_id;
      this.editProdSalorDlg.form.owner =
        Number(item.owner) === 0 ? '' : item.owner;
      this.editProdSalorDlg.form.owner &&
        (this.editProdSalorDlg.options = [
          { id: item.owner, name: item.owner_name },
        ]);
      this.editProdSalorDlg.visible = true;
    },
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            name: key,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.data || [];
      } catch (err) {
        this.$message.error(`获取客保销售失败：${err.message || '未知错误'}`);
      }
    },
    submitEditProdSalor() {
      this.$refs.prodSalorForm.validate((valid) => {
        if (valid) {
          this._processEditProdSalor();
        } else {
          return false;
        }
      });
    },
    async _processEditProdSalor() {
      try {
        this.editProdSalorDlg.loading = true;
        await req
          .send(req.Apis.customer.common.updateCustomerSales, {
            ...this.editProdSalorDlg.form,
            owner: this.editProdSalorDlg.form.owner || 0,
          })
          .fin(() => {
            this.editProdSalorDlg.loading = false;
          });
        this.editProdSalorDlg.visible = false;
        this.$message.success('修改成功');
        this._getCustomerList();
      } catch (err) {
        this.$message.error(`修改失败：${err.message || '未知错误'}`);
      }
    },
    async _getCustomerList() {
      try {
        this.table.loading = true;

        const res = await req
          .send(req.Apis.customer.common.customerList, this.query)
          .fin(() => {
            this.table.loading = false;
          });

        const list = res.data.data || [];
        list.forEach((item) => {
          item._sales = (item.sales && item.sales.join(',')) || '--';
          const _prods = this._returnProductsName(item);
          item._prods = _prods.map((i) => i.product_name);
          item._prodOps = _prods;
        });
        this.table.list = list;
        this.table.total = Number(res.data.total || 0);
      } catch (err) {
        this.$message.error(`获取客户列表失败：${err.message || '未知错误'}`);
      }
    },

    async _deleteCustomer() {
      try {
        await req.send(
          req.Apis.customer.common.delCustomer,
          this.deleteCustomerDlg.form,
        );

        this.$message.success('删除客户成功');
        this._getCustomerList();
      } catch (err) {
        this.$message.error(`客户删除失败：${err.message || '未知错误'}`);
      }
    },

    async _processModifyCompany() {
      try {
        this.modifyCompanyDlg.loading = true;
        await req
          .send(
            req.Apis.customer.common.updateCompany,
            this.modifyCompanyDlg.form,
          )
          .fin(() => {
            this.modifyCompanyDlg.loading = false;
          });
        this.modifyCompanyDlg.visible = false;
        this.$message.success('公司名称修改成功');
        this._getCustomerList();
      } catch (err) {
        this.$message.error(`修改公司名失败：${err.message || '未知错误'}`);
      }
    },

    async _processBindAdv() {
      try {
        this.bindAdvDlg.loading = true;
        await req
          .send(req.Apis.customer.common.bindADV, this.bindAdvDlg.form)
          .fin(() => {
            this.bindAdvDlg.loading = false;
          });
        this.bindAdvDlg.visible = false;
        this.$message.success('绑定成功');
        this._getCustomerList();
      } catch (err) {
        this.$message.error(`绑定失败：${err.message || '未知错误'}`);
      }
    },

    async _processEditProd() {
      // 交集
      const _selected = this.editProdDlg.selectedProd;
      const _init = this.editProdDlg.initSelectedProds;
      const _intersect = _selected.filter((i) => _init.includes(i)) || [];
      // 计算 增加、删减项
      const _deleted = _init.filter((i) => !_intersect.includes(i));
      const _added = _selected.filter((i) => !_intersect.includes(i));

      try {
        this.editProdDlg.form.add_pids = _added.join(',') || '';
        this.editProdDlg.form.sub_pids = _deleted.join(',') || '';

        this.editProdDlg.loading = true;
        await req
          .send(req.Apis.customer.common.updateProd, this.editProdDlg.form)
          .fin(() => {
            this.editProdDlg.loading = false;
          });
        this.editProdDlg.visible = false;
        this.$message.success('产品修改成功');
        this._getCustomerList();
      } catch (err) {
        this.$message.error(`产品修改失败：${err.message || '未知错误'}`);
      }
    },

    async _searchAdv(key) {
      if (!key) return [];
      try {
        this.bindAdvDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.searchBindableAcc, {
            adv_user_id: key,
          })
          .fin(() => {
            this.bindAdvDlg.searchLoading = false;
          });
        this.bindAdvDlg.saleOps = res.data || [];
      } catch (err) {
        this.$message.error(`获取adv列表失败：${err.message || '未知错误'}`);
      }
    },

    async _searchProduct(key) {
      if (!key) return [];
      try {
        this.editProdDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.prodDetail, { name: key })
          .fin(() => {
            this.editProdDlg.searchLoading = false;
          });
        const prods = (res.data || []).map((i) => ({
          product_id: i.product_id,
          product_name: i.product_name,
        }));
        this.editProdDlg.prodOps = [
          ...new Set(
            [...this.editProdDlg.prodOps, ...prods].map((i) =>
              JSON.stringify(i),
            ),
          ),
        ].map((i) => JSON.parse(i));
      } catch (err) {
        this.$message.error(`获取产品列表失败：${err.message || '未知错误'}`);
      }
    },

    handleFilter() {
      this.query.page = 1;
      this._getCustomerList();
    },

    handleReset() {
      const pageSize = this.query.page_size;
      this.query = {
        ...createDefaultQuery(),
        page_size: pageSize,
      };
      // this._getCustomerList();
    },

    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    handlePageSizeChange(pageSize) {
      this.query.page_size = Number(pageSize);
      this._getCustomerList();
    },

    handleQueryPage(page) {
      this.query.page = Number(page);
      this._getCustomerList();
    },

    toProductList(item = {}) {
      let routeUrl = this.$router.resolve({
        name: 'OperationManageCustomerProductList',
        query: {
          customerId: item.customer_id || '',
        },
      });
      window.open(routeUrl.href, '_blank');
    },

    _returnProductsName(item = {}) {
      let _prod = item.product || {};
      return [...(_prod.cooperation || []), ...(_prod.un_cooperation || [])];
    },

    _operate([fn, item]) {
      fn.call(this, item);
    },

    deleteCustomer(item) {
      this.deleteCustomerDlg.form.customer_id = item.customer_id || '';
      this.$confirm(`将删除【${item.company || ''}】, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this._deleteCustomer();
      });
    },

    modifyCompanyName(item) {
      this.modifyCompanyDlg.visible = true;
      this.modifyCompanyDlg.form.customer_id = item.customer_id || '';
      this.modifyCompanyDlg.form.company = item.company || '';
    },

    submitModifyCompanyForm() {
      this.$refs.modifyCompanyForm.validate((valid) => {
        if (valid) {
          this._processModifyCompany();
        } else {
          return false;
        }
      });
    },

    bindADV(item) {
      this.bindAdvDlg.saleOps = [];
      this.bindAdvDlg.prodOps = item._prodOps || [];
      this.bindAdvDlg.form.customer_id = item.customer_id || '';
      this.bindAdvDlg.form.product_id = '';
      this.bindAdvDlg.form.adv_user_id = '';
      this.bindAdvDlg.visible = true;
    },

    submitBindAdvDlgForm() {
      this.$refs.bindAdvForm.validate((valid) => {
        if (valid) {
          this._processBindAdv();
        } else {
          return false;
        }
      });
    },

    modifyProduct(item) {
      const _prods = item.product || {};
      const _uncoProds = _prods.un_cooperation || [];
      const _uncoProdsObj = _uncoProds.map((i) => ({
        product_id: i.product_id,
        product_name: i.product_name,
      }));
      const _uncoProdsIds = _uncoProds.map((i) => i.product_id);

      this.editProdDlg.prods = _prods.cooperation || [];
      this.editProdDlg.initSelectedProds = _uncoProdsIds;
      this.editProdDlg.selectedProd = _uncoProdsIds;
      this.editProdDlg.prodOps = _uncoProdsObj;
      this.editProdDlg.form.customer_id = item.customer_id || '';
      this.editProdDlg.visible = true;
    },
  },
};
</script>
<style lang="less">
.customer-list-page {
  .query-conditions {
    margin-bottom: 24px;
  }

  .query-form {
    width: 100%;
  }

  .query-item {
    margin-bottom: 12px;
  }

  .query-item--actions {
    display: flex;
    align-items: flex-start;
  }

  .query-buttons {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .query-toggle {
    padding: 0;
  }

  .query-conditions .el-form-item {
    display: block;
    width: 100%;
    margin-right: 0;
    margin-bottom: 0;
  }

  .query-conditions .el-form-item__content {
    width: 100%;
  }

  .query-buttons .el-button + .el-button {
    margin-left: 0;
  }
}
</style>
